module.exports = __webpack_public_path__ + "assets/Invisalign-clear-aligners.df9795235791fc14398d83c67c25e98e.png";